
export default {
  name: 'HomeSection',
  props: {
    title: {
      type: String,
      default: null,
    },
    tag: {
      type: String,
      default: 'h2',
    },
    tone: {
      type: String,
      default: 'plain',
    },
    link: {
      type: Object,
      default: null,
    },
    boxed: {
      type: Boolean,
      default: false,
    },
    anchor: {
      type: String,
      default: null,
    },
    titleClass: {
      type: String,
      default: null,
    },
  },
  methods: {
    hasHead() {
      return Boolean(this.title || this.link || this.$slots.aside)
    },
  },
}
